module.exports = __webpack_public_path__ + "static/media/2007_GDP_totalRate.52a62a09.png";